export const Sobre = () => {
    return (
        <>
            <div className="sobreArea">
                <h1>Sobre mim</h1>
                <p>
                Me chamo Isaac, tenho 19 anos, sou cristão e apaixonado por tecnologia. Descobri a programação no início do 3º ano do ensino médio e, desde então, ela se tornou o meu sonho. Independentemente do emprego, foi na programação que me encontrei. Adoro resolver problemas, e apesar dos bugs demorarem para ser resolvidos às vezes, a sensação de superá-los é extremamente gratificante.

                Além da programação, também toco teclado, o que me proporciona um equilíbrio entre minha paixão por tecnologia e minha conexão com a música. Atualmente, ainda não trabalho na área de TI, mas estou em busca de oportunidades para ingressar no mercado. Sei que, por mais que demore, não vou desistir do meu objetivo.
                </p>
            </div>
        </>
    )
}